import React, { useState, useEffect } from 'react';
import Box from "@mui/material/Box";
import Typography from '@mui/material/Typography';
import Button from "@mui/material/Button";
import { useTranslation, Trans } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

const WaWarning = ({ children }) => {
  const [showWarning, setShowWarning] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const ua = navigator.userAgent || "";
    // Android || iPhone, checked 2026-03-23
    if (ua.includes('WA4A') || ua.includes('WAiOS')) {
      setShowWarning(true);
    }
  }, []);

  if (showWarning) {
    return (
      <Box sx={{
        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: '#fff', p: 3, zIndex: 9999, overflowY: 'auto',
        backgroundImage: "url('data:image/svg+xml;charset=UTF-8,%3csvg width=\"6\" height=\"22\" viewBox=\"0 0 6 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath d=\"M3.00598 3.13824C3.00598 2.8621 2.78212 2.63824 2.50598 2.63824C2.22984 2.63824 2.00598 2.8621 2.00598 3.13824L2.50598 3.13824L3.00598 3.13824ZM2.50598 21.4279L3.00598 21.4279L3.00598 3.13824L2.50598 3.13824L2.00598 3.13824L2.00598 21.4279L2.50598 21.4279Z\" fill=\"%23BE0000\"/%3e%3cpath d=\"M3.99219 6.2959H1.02051L2.50586 1.64355L3.99219 6.2959Z\" fill=\"%23BE0000\" stroke=\"%23BE0000\"/%3e%3c/svg%3e')",
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top 12px right 12px',
        backgroundSize: '1.5rem auto'
      }}>
        <Box sx={{ mb: 4 }}>
          <LanguageSelector />
        </Box>

        <Box sx={{ pr: 8 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: '#d32f2f' }}>{t('waWarning.title')}</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            <Trans i18nKey="waWarning.description" components={{ strong: <strong /> }} />
          </Typography>
          <Box component="ol" sx={{ ml: 2, mb: 4 }}>
            <Typography component="li" sx={{ mb: 1 }}>{t('waWarning.step1')}</Typography>
            <Typography component="li" sx={{ mb: 1 }}>
              <Trans i18nKey="waWarning.step2" components={{ strong: <strong /> }} />
            </Typography>
          </Box>
        </Box>

        <Button 
          variant="outlined" 
          fullWidth 
          onClick={() => setShowWarning(false)}
          sx={{ mt: 2 }}
        >
          {t('waWarning.cta')}
        </Button>
      </Box>
    );
  }

  return <>{children}</>;
};

export default WaWarning;
